Object.defineProperty(exports, '__esModule', {
  value: true
});
var _tslib = require('../../_tslib-1246030c.js');
var dateFns = require('date-fns');
var DateFnsUtils = require('@date-io/date-fns');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var DateFnsUtils__default = /*#__PURE__*/_interopDefaultLegacy(DateFnsUtils);
var CustomDateFnsUtils = /** @class */function (_super) {
  _tslib.__extends(CustomDateFnsUtils, _super);
  function CustomDateFnsUtils() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Overrides the default `getYearRange` function to return the years in
   * descending order
   *
   * @param {Date} start Starting date, will be the last item in the returned
   * array
   * @param {*Date end Ending date, will be the first item in the returned
   * array
   *
   * @returns {Date[]} An array of dates, one for each year in the range between
   * the supplied start and end dates
   */
  // eslint-disable-next-line class-methods-use-this
  CustomDateFnsUtils.prototype.getYearRange = function (start, end) {
    var startDate = dateFns.startOfYear(end);
    var endDate = dateFns.endOfYear(start);
    var years = [];
    var current = startDate;
    while (dateFns.isAfter(current, endDate)) {
      years.push(current);
      current = dateFns.subYears(current, 1);
    }
    return years;
  };
  return CustomDateFnsUtils;
}(DateFnsUtils__default['default']);
exports.CustomDateFnsUtils = CustomDateFnsUtils;